module.exports = __webpack_public_path__ + "static/media/a.afb2396a.png";